import { Action } from 'redux';

import { UpdateAlertTotal } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';

export interface UpdateAlertTotalAction extends Action {
  total: number;
}

export function updateAlertTotalAction(total: number): UpdateAlertTotalAction {
  return {
    type: UpdateAlertTotal,
    total: total
  };
}

export const isUpdateAlertTotalAction = isActionFactory<UpdateAlertTotalAction>(UpdateAlertTotal);
